<div class="login-container">
  <div class="login-container__form">
    <div class="login-container__form__inner">
      <img
        class="login-container__form__inner__logo"
        src="../../assets/img/jt-logo-big.svg" />
      <h1>{{translationPrefix + 'apple-id.finish' | translate }}</h1>

      <div class="login-container__form__inner__footer">
        <div class="login-container__form__inner__footer__label">
          {{ translationPrefix + 'footerLabel' | translate }}
        </div>
        <div class="login-container__form__inner__footer__value">
          {{ translationPrefix + 'footerValue' | translate }}
        </div>
      </div>
    </div>
  </div>

  <div class="login-container__cover">
    <img
      class="login-container__cover__image"
      src="assets/img/krystal-bg-3%203x.jpg" />
  </div>
</div>

